import { useTranslation } from 'react-i18next';
import { ClinicoSignupCard } from './ClinicoSignupCard';
import { ClinicoIntegratedManagement } from './ClinicoIntegratedManagement';
import { ClinicoDigitalManagement } from './ClinicoDigitalManagement';

export default function ClinicoDetails() {
    const { t } = useTranslation();

    return (
        <div className="mt-[86px] mainContainer">
            <div className="pb-[50px]">
                <h2 className="lg:text-[38px] sm:text-[32px] text-[28px] font-bold text-primary-text">
                    {t('clinicoPage.overviewTitle')}
                </h2>
                <span className="w-full h-[1px] bg-[#BFD1D3] mt-[32px] block mb-3"></span>
                <div>
                    <h6 className="md:text-[24px] text-[20px] font-semibold text-primary-text my-[24px]">
                        {t('clinicoPage.overviewLabel')}
                    </h6>
                    <p className="text-primary-text font-medium my-6 sm:text-[20px] text-[15px]">
                        {t('clinicoPage.description')}
                    </p>
                </div>
            </div>
            <div className="flex flex-col gap-10">
                <ClinicoIntegratedManagement
                    icon="doctorAmico"
                    title={t('clinicoPage.details.integrated.title')}
                    description={t('clinicoPage.details.integrated.description')}
                />

                <ClinicoDigitalManagement
                    title={t('clinicoPage.details.digital.title')}
                    description={t('clinicoPage.details.digital.description')}
                />

                <ClinicoIntegratedManagement
                    icon="investmentData"
                    title={t('clinicoPage.details.finance.title')}
                    description={t('clinicoPage.details.finance.description')}
                />
            </div>

            <ClinicoSignupCard />
        </div>
    );
}
